import { SvgBase } from "../svg.base";

export const AppleLogo = () => (
    <SvgBase
        width="24"
        height="24"
        viewBox="0 0 24 30"
    >
        <defs>
            <filter id="xp93z3sfla">
                <feColorMatrix in="SourceGraphic" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0" />
            </filter>
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g filter="url(#xp93z3sfla)" transform="translate(-1317 -701) translate(1274 701)">
                    <g>
                        <path fill="#FFF" fillRule="nonzero" d="M12.129 8.71c-1.159 0-2.951-1.361-4.84-1.312-2.49.033-4.775 1.493-6.06 3.806-2.586 4.642-.667 11.499 1.856 15.272 1.238 1.837 2.697 3.904 4.633 3.838 1.856-.082 2.554-1.246 4.807-1.246 2.237 0 2.872 1.246 4.84 1.197 1.998-.033 3.268-1.87 4.49-3.724 1.411-2.132 1.998-4.199 2.03-4.314-.047-.016-3.887-1.542-3.935-6.135-.031-3.838 3.03-5.676 3.174-5.758-1.746-2.64-4.427-2.936-5.363-3.001-2.443-.197-4.49 1.377-5.632 1.377zm4.125-3.87c1.031-1.28 1.713-3.068 1.523-4.84-1.476.066-3.253 1.017-4.316 2.297-.952 1.131-1.777 2.952-1.555 4.691 1.635.131 3.316-.87 4.348-2.149" transform="translate(43)" />
                    </g>
                </g>
            </g>
        </g>
    </SvgBase>
);


